module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-two-tone.woff2?4ef4218c522f1eb6b5b1d8b7df0385ce";